/**
 * Copyright (c) 2019, Tidepool Project
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the associated License, which is identical to the BSD 2-Clause
 * License as published by the Open Source Initiative at opensource.org.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the License for more details.
 *
 * You should have received a copy of the License along with this program; if
 * not, you can obtain one from Tidepool Project at tidepool.org.
 */

import React, { useEffect } from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
	 aligned: {
	    display: 'flex',
	    flexDirection: 'column',
	    'margin-left': 'auto',
	    'margin-right': 'auto',
	    'align-items': 'center',
  	},
}));

// Very simple "Done" page for after a prescription gets sent
const Done = props => {
	const classes = useStyles();

	// scroll to top on mount
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

	return (
		<div className={classes.aligned} >
			<Typography variant="h6" color="textSecondary" >
				{props.firstName ? props.firstName + "'s" : "Your"} prescription has been sent!
			</Typography>
		</div>
	);
}

export default Done;